import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.816 7.334 11.656.335C11.456.14 11.3 0 11 0H1C.4 0 0 .39 0 .977v9.776c0 .294.143.447.343.642l7.159 6.999c.6.586 1.357.922 2.057.922.8 0 1.467-.326 2.067-.912l7.2-7.04c1.2-1.172 1.19-2.857-.01-4.03m-1.385 2.668-7.2 7.038a.98.98 0 0 1-1.4 0L2 10.362V1.955h8.6l6.831 6.678c.4.391.4.978 0 1.369M5.3 5.181c-.2.196-.3.391-.3.684s.1.49.3.685.4.293.7.293.5-.098.7-.293c.2-.196.3-.391.3-.685 0-.293-.1-.488-.3-.684a.98.98 0 0 0-1.4 0"
    }, null, -1)
  ]))]))
}
export default { render: render }